import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, MenuItem, InputLabel, FormControl, FormControlLabel, Checkbox, Stack } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  
 
  const [fullName, setFullName] = React.useState("");
  const [employeeNumber, setEmployeeNumber] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [active, setActive] = React.useState(true);
  const [userType, setUserType] = React.useState(false);
  const [roleId, setRoleId] = React.useState(0);
  const [roleName, setRoleName] = React.useState("noselect");
  const [reportToId, setReportToId] = React.useState(0);
  const [reportToName, setReportToName] = React.useState("noselect");
  const [reportToIdOld, setReportToIdOld] = React.useState(0);
  const [otpLogin, setOtpLogin] = React.useState(false);
  const [otpMobileNumber, setOtpMobileNumber] = React.useState("");

  const [roles, setRoles] = React.useState([]);
  const [users, setUsers] = React.useState([]);

  const [salesTarget, setSalesTarget] = React.useState(0);
  


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    if(props.userObj && open){
			getApiDataMix();
		}
    if(props.dataObj!=null && props.dataObj.autoId && open){	
      setFullName(props.dataObj.fullName);
      setEmployeeNumber(props.dataObj.employeeNumber);
      setDescription(props.dataObj.description);
      setMobile(props.dataObj.mobile);
      setEmail(props.dataObj.email);
      setRoleId(props.dataObj.roleId);
      setRoleName(props.dataObj.roleName);
      setReportToIdOld(props.dataObj.reportToId);
      setReportToId(props.dataObj.reportToId);
      setReportToName(props.dataObj.reportToName);      
      setOtpMobileNumber(props.dataObj.otpMobileNumber);
      setSalesTarget(props.dataObj.salesTarget);

      setPassword("");
      if(props.dataObj.active && props.dataObj.active===1){
        setActive(true);
      }else{
        setActive(false);
      }
      if(props.dataObj.userType && props.dataObj.userType===1){
        setUserType(true);
      }else{
        setUserType(false);
      }
      if(props.dataObj.otpLogin && props.dataObj.otpLogin===1){
        setOtpLogin(true);
      }else{
        setOtpLogin(false);
      }

    }else{
      setFullName("");
      setEmployeeNumber("");
      setDescription("");
      setMobile("");
      setEmail("");
      setPassword("");
      setActive(true);      
      setUserType(false);
      setRoleId(0);
      setRoleName("noselect");
      setReportToIdOld(0);
      setReportToId(0);
      setReportToName("noselect");
      setOtpLogin(false);
      setOtpMobileNumber("");
      setSalesTarget(0);
            
    }

    

	}, [props.userObj,props.dataObj,open]);
  

  async function getApiDataMix(){ 
    let apiUrl=API_URL+'/crmix-for-agent-form';
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setRoles(response.data.obj.roleList);
        setUsers(response.data.obj.userList);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setRoles([]);
        setUsers([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      }
    })
  }

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

	function saveData(){
    if(!fullName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter full Name");			
      return false;
    }
    if(!mobile){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter mobile");			
      return false;
    }
    if(!roleId && props.userObj.packageId>1){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select role");			
      return false;
    }

    
    if(email && email.length>0 && !validateEmail(email) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Email is not valid.");			
      return false;
    }

		if(fullName){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
        data.append('loginId', props.dataObj.loginId);        
      } 
                  
      data.append('fullName', fullName);
      data.append('mobile', mobile);
      data.append('email', email);
      if(password && password.length>3){
        data.append('password', password);
      }else{
        data.append('password', "");
      }
      data.append('employeeNumber', employeeNumber);
      data.append('description', description);

      if(roleId && roleId>0){
        data.append('roleId', roleId);
        data.append('roleName', roleName);
      }

      if(reportToId && reportToId>0){
        data.append('reportToId', reportToId);
        data.append('reportToName', reportToName);
      }

      if(reportToIdOld && reportToIdOld>0){
        data.append('reportToIdOld', reportToIdOld);
      }else{
        data.append('reportToIdOld', 0);
      }

      if(reportToIdOld!==reportToId){
        data.append('changeFlag', 1);
      }else{
        data.append('changeFlag', 0);
      }

      data.append('otpMobileNumber', otpMobileNumber);
      
      if(active===true){
        data.append('active', 1);
      }else{
        data.append('active', 0);
      }

      if(props.userObj.packageId>1){
        if(userType===true){
          data.append('userType', 1);
        }else{
          data.append('userType', 0);
        }
      }else{
        data.append('userType', 1);
      }

      if(otpLogin===true){
        data.append('otpLogin', 1);
      }else{
        data.append('otpLogin', 0);
      }

      if(salesTarget && salesTarget>0){
        data.append('salesTarget', salesTarget);
      }else{
        data.append('salesTarget', 0);
      }

      let apiURL='/crm-create-crmusers';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-crmusers';
      }
      setLoadingBtn(true);
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setLoadingBtn(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Agent has been saved.");
          window.location.reload();	
					return false;
				}else if(response.data.responseTxt==="mobileAlreadyExistsError"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Mobile already added with another user.");			
					return false;
				}else if(response.data.responseTxt==="emailAlreadyExistsError"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Email already added with another user.");			
					return false;
        }else if(response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';
        }else if(response.data.responseTxt==="limitexceeded"){
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Your app limit exceeded. You must upgrade your package to add more agent.");			
            return false;  
        }else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Agent could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  function handleRoles(val){
    setRoleName(val);
    if(roles){
      for(let i=0; i<roles.length; i++){
        if(roles[i].roleName===val){
          setRoleId(roles[i].autoId);          
          break;
        }
      }
    }
  }

  function handleReportTo(val){    
    if(val){
      let arr = val.split('#');
      setReportToId(arr[0]);
      setReportToName(arr[1]);   
    }
  }
  
  function numberOnly(event){
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    } 
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{(props.dataObj!=null && props.dataObj.autoId)?<>Edit</>:<>New</>} Agent</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={6} xs={12} >
                              <TextField label="Full Name" onChange={event => setFullName(event.target.value)} value={fullName} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Mobile" onChange={event => setMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={mobile} fullWidth variant="outlined" inputProps={{maxlength:10}} size='small' />
                          </Grid>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Email" onChange={event => setEmail(event.target.value)} value={email} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField type="password" autoComplete="off" label="Password" onChange={event => setPassword(event.target.value)} value={password} fullWidth variant="outlined" size='small' />
                          </Grid>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Employee Number" onChange={event => setEmployeeNumber(event.target.value)} value={employeeNumber} fullWidth variant="outlined" size='small' />
                          </Grid>

                        {props.userObj.packageId>1?
                          <Grid item md={6} xs={12} >
                              <Grid container spacing={2}>
                                <Grid item xs={4} >
                                    <FormControlLabel
                                      control={
                                        <Checkbox checked={otpLogin} onChange={event => setOtpLogin(event.target.checked)} />
                                      }
                                      label="OTP Login"
                                    />
                                </Grid>
                                <Grid item xs={8} >
                                  <TextField size='small' label="OTP Mobile Number" onChange={event => setOtpMobileNumber(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={otpMobileNumber} fullWidth variant="outlined" inputProps={{ maxLength: 10 }} />
                                </Grid>
                              </Grid>
                          </Grid>
                        :null}
                          
                          {props.userObj.packageId>1?<>
                          <Grid item md={6} xs={12} >
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Role</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={roleName}
                                  label="Role"                                  
                                  onChange={event => handleRoles(event.target.value)}
                                >
                                  <MenuItem key={'at'} value={'noselect'}>Select Role</MenuItem>
                                  {roles?roles.map((myRow,mykey)=>(
                                    <MenuItem key={'at'+mykey} value={myRow.roleName}>{myRow.roleName}</MenuItem>
                                  )):null}
                                </Select>
                              </FormControl>
                          </Grid>
                          <Grid item md={6} xs={12} >
                          <FormControl fullWidth size="small">
                              <InputLabel id="demo-simple-select-label">Report To</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={reportToId+'#'+reportToName}
                                label="Report To"                                  
                                onChange={event => handleReportTo(event.target.value)}
                              >
                                <MenuItem key={'at'} value={'0#noselect'}>Select</MenuItem>
                                {users?users.map((myRow,mykey)=>(
                                  <MenuItem key={'u'+mykey} value={myRow.autoId+'#'+myRow.fullName}>{myRow.fullName}</MenuItem>
                                )):null}
                              </Select>
                            </FormControl>
                        </Grid>
                        </>:null}

                          <Grid item md={6} xs={12} >
                              <TextField label="Sales Target" onChange={event => setSalesTarget(event.target.value)} value={salesTarget} fullWidth variant="outlined" multiline size='small' />
                          </Grid>

                          <Grid item md={6} xs={12} >
                              <TextField label="Other Details" onChange={event => setDescription(event.target.value)} value={description} fullWidth variant="outlined" multiline size='small' />
                          </Grid>
                          
                          
                          <Grid item md={6} xs={12} >
                              <FormControlLabel
                                control={
                                  <Checkbox checked={active} onChange={event => setActive(event.target.checked)} />
                                }
                                label="Active"
                              />
                              {props.userObj.packageId>1?
                              <FormControlLabel
                                control={
                                  <Checkbox checked={userType} onChange={event => setUserType(event.target.checked)} />
                                }
                                label="Admin"
                              />
                              :null}
                          </Grid>               
                          
                          

                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"
                              startIcon={<div style={{marginRight:15}} ></div>}											
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Saving...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }  
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;